import { takeLatest, put } from 'redux-saga/effects';

import {
  CANCEL_PERFIL_CADASTRO_RAPIDO,
  CANCEL_PERFIL_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelPerfilCadastroRapido() {
  yield put({ type: CANCEL_PERFIL_CADASTRO_RAPIDO_SUCCESS })
}

export default function* watchCancelPerfilCadastroRapido() {
  yield takeLatest(CANCEL_PERFIL_CADASTRO_RAPIDO, sagaCancelPerfilCadastroRapido)
}